import { cn } from '@/lib/cn';

/**
 * A slightly faster-than-default spinner (0.75s instead of 1s) so the UI
 * *feels* snappier even when load time is identical. Emil's
 * perceived-performance rule in practice.
 */
export function Spinner({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn(
        'inline-block h-5 w-5 animate-spin rounded-full border-2 border-ink-muted/40 border-r-transparent [animation-duration:0.75s]',
        className,
      )}
    />
  );
}

export function FullPageSpinner() {
  return (
    <div className="flex h-full items-center justify-center py-20">
      <Spinner className="h-6 w-6 border-ink-muted/50" />
    </div>
  );
}
